import(/* webpackMode: "eager" */ "/codebuild/output/src4017316730/src/src/app/global-error.tsx");
